module.exports = __webpack_public_path__ + "assets/img/202110-5.c93bd279.png";